<template>
    <v-row>
        <v-col cols="12" class="pt-8 pb-2"><v-divider /></v-col>
        <v-col cols="12">
            <small>
                &copy; 2020 Aurich Münch Ziegler Steuerberater PartGmbB<br/>
                Bitte beachten Sie, dass der Reiskostenrechner nur für steuerliche Zwecke/Sachverhalte - nicht zur Abrechnung gegenüber dem Arbeitgeber - ausschließlich bezogen auf die Bundesrepublik Deutschland entwickelt wurde und insbesondere bei Besonderheiten im Sachverhalt eine individuelle Prüfung/Beratung nicht ersetzen kann.
            </small>
        </v-col>
    </v-row>
</template>

<script>
    export default {
        name: "Disclaimer"
    }
</script>

<style scoped>

</style>